module.exports = __webpack_public_path__ + "img/YQD_TC.214ebe44.jpg";